import { useState, useEffect, useRef } from "react";
import { fetchProducts } from "../../../API_Handler";
import { MagnifyingGlassIcon } from "../../../../Constants/Icons";
import ProductsModal from "./ProductsModal";


const Vendors = ({ productsList, scrollTo }) => {

    const [loading, setLoading] = useState(false);
    const [products, setProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);


    useEffect(() => {
        const fetchProductsData = async () => {
            setLoading(true);
            const products = await fetchProducts();
            setProducts(products);
            setFilteredProducts(products);
            setLoading(false);
        };

        if (productsList) {
            setProducts(productsList);
            setFilteredProducts(productsList);
        } else {
            fetchProductsData();
        }
    }, []);

    useEffect(() => {
        const scrollToProduct = async () => {
            if (scrollTo) {
                const elementId = String(scrollTo);
                const element = document.getElementById(elementId);
                if (element) {
                    console.log("Scrolling to element", elementId);
                    element.scrollIntoView({ behavior: 'smooth' });
                }
                else {
                    console.log("Element not found", elementId);
                }
            }
        }

        scrollToProduct();
    }, [filteredProducts, scrollTo]);

    const [searchTerm, setSearchTerm] = useState("");

    const handleChange = (event) => {
        let value = event.target.value;
        setSearchTerm(value);

        const filtered = products.filter((product) =>
            (product.contact_email && product.contact_email.toLowerCase().includes(value.toLowerCase())) ||
            (product.description && product.description.toLowerCase().includes(value.toLowerCase())) ||
            (product.name && product.name.toLowerCase().includes(value.toLowerCase())) ||
            (product.date_registered && product.date_registered.includes(value)) ||
            (product.id && product.id.includes(value))
        );
        setFilteredProducts(filtered);
    };

    return (
        <div>
            {loading ?
                <div className="w-full h-screen flex flex-col items-center justify-center">
                    <div className="spinner-border" role="status"> </div>
                    <p className="mt-[12px] text-center font-proximanova text-[18px] text-[#505050] font-[400]">Loading...</p>
                </div>
                :
                <div className="w-full h-[calc(100vh-60px)] flex flex-col overflow-y-auto">
                    <div className="w-full px-[28px] gap-[16px] flex flex-row items-center bg-white border-exploreSearchBorder border-1 rounded-full relative">
                        <div className="w-full flex justify-center">
                            <input
                                type="text"
                                className="w-full h-10 focus:outline-none font-proximanova text-[18px] text-[#505050] mb-0" placeholder="Search for vendors"
                                value={searchTerm}
                                onChange={handleChange}
                            />
                            <button className="w-fit">
                                <MagnifyingGlassIcon />
                            </button>
                        </div>
                    </div>

                    <div className="mt-[16px] flex flex-col bg-white mb-[16px]">
                        <div className="w-full px-[16px] flex flex-row">
                            <p className="min-w-[60px] max-w-[60px] pr-[16px] font-proximanova text-[18px] text-[#505050] border-r-[1px] border-[#a0a0a0] mb-0">ID</p>
                            <p className="w-full pl-[16px] font-proximanova text-[18px] text-[#505050] text-left font-[600] mb-0"> Product Name</p>
                            <div className="flex flex-row justify-between">
                                <p className="w-[168px] pl-[16px] font-proximanova text-[18px] text-[#505050] text-left font-[600] mb-0 border-l-[1px] pl-[16px] border-[#a0a0a0]"> Status</p>
                                <p className="w-[80px] pl-[16px] font-proximanova text-[18px] text-[#505050] text-left font-[600] mb-0 border-l-[1px] pl-[16px] border-[#a0a0a0]"> Action</p>
                            </div>
                        </div>
                        {filteredProducts && filteredProducts.length > 0 &&
                            filteredProducts.reduce((acc, product) => {
                                const isEven = acc.length % 2 === 0;
                                acc.push(
                                    <div id={`${product.id}`}>
                                    <ProductsModal
                                        key={product.id}
                                        selectedProduct={product}
                                        backgroundColor={isEven ? 'bg-[#e6e6e6]' : 'bg-[#f5f5f5]'}
                                        defaultExpanded={scrollTo === product.id}
                                    />
                                    </div>

                                    // <div className={`w-full h-fit flex flex-col ${isEven ? 'bg-[#e6e6e6]' : 'bg-[#f5f5f5]'} ${expandedVendor?.id === product.id ? 'border-[1px] border-charmOrange py-[6px]' : 'py-[3px]'}`} key={product.id}>
                                    //     <div className={`w-full px-[16px] flex flex-row justify-between ${expandedVendor?.id === product.id ? 'pb-[6px] border-b-[1px] border-[#a0a0a0]' : ''}`}>
                                    //         <p className="min-w-[60px] max-w-[60px] pr-[16px] font-proximanova text-[18px] text-[#505050] border-r-[1px] border-[#a0a0a0] mb-0"> {product.id}</p>
                                    //         <p className="w-full pl-[16px] font-proximanova text-[18px] text-[#505050] text-left font-[600] mb-0"> {product.company_name}</p>

                                    //         <div className="flex flex-row justify-between">
                                    //             <div className="w-fit flex flex-row items-center border-l-[1px] pl-[16px] border-[#a0a0a0] gap-[8px]">
                                    //                 <div className={`w-[8px] h-[8px] rounded-full ${product.approval_status === "PENDING" ? 'bg-[#bbbbbb]' : product.approval_status === "APPROVED" ? 'bg-[#76da24]' : product.approval_status === "REJECTED" ? 'bg-[#fd5764]' : ''} `}></div>
                                    //                 <p className="min-w-[104px] max-w-[104px] font-proximanova text-[18px] text-[#505050] mb-0">{product.approval_status}</p>
                                    //             </div>

                                    //             <div className="border-l-[1px] pl-[16px] border-[#a0a0a0] flex flex-row items-center justify-center">
                                    //                 {expandedVendor === null || expandedproduct.id !== product.id ?
                                    //                     (<button className="flex flex-row items-center justify-center font-proximanova text-charmOrange text-[18px] hover:text-charmHover border-b-[1px] border-charmOrange hover:border-charmHover mb-0"
                                    //                         onClick={() => setExpandedVendor(vendor)}
                                    //                     >
                                    //                         Expand
                                    //                     </button>
                                    //                     ) :
                                    //                     (<button className="flex flex-row items-center justify-center font-proximanova text-charmOrange text-[18px] hover:text-charmHover border-b-[1px] border-charmOrange hover:border-charmHover mb-0"
                                    //                         onClick={() => setExpandedVendor(null)}
                                    //                     >
                                    //                         Collapse
                                    //                     </button>
                                    //                     )}
                                    //             </div>
                                    //         </div>
                                    //     </div>

                                    //     {expandedVendor && expandedproduct.id === product.id && (
                                    //         <div className={`mt-[16px] w-full ${expandedVendor?.id === product.id ? 'px-[16px]' : ''}`} >
                                    //             <VendorModal
                                    //                 selectedVendor={vendor}
                                    //                 onChange={() => setModalChange(prev => !prev)}
                                    //             />
                                    //         </div>
                                    //     )}
                                    // </div>
                                );
                                return acc;
                            }, [])
                        }
                    </div>

                </div>

            }
        </div >
    );
};

export default Vendors;